/**
 * @file 状态管理
 * @author hardylin <hardylin@tencent.com>
 */
import Vue from 'vue'
import Vuex from 'vuex'
import {getUrlParam} from './utils/index'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {

        // 全局模块
        global: {
            namespaced: true,

            state: {
                game: location.pathname.match(/^\/([^\/]*)\/\w*/)[1], // 游戏标识
                gameInfo: {}, // 游戏基本信息
                config: {}, // 微社区配置
                labels: {}, // 标签信息
                knowledge: {}, // 微社区知识点
                knowledgeMap: {}, // 知识点 map 结构
                knowledgeSpread: {}, // 知识点展开后的 map 结构
                isFirst: false, // 是否首次访问
                userInfo: { // 个人信息
                    // avatar,
                    // gender. // 性别：1（男），2（女）
                    // nickname,
                    openid: getUrlParam('openid', sessionStorage.tokenParams)
                },
                position: { // 位置信息
                    // accuracy: 38, // 精度
                    // addr: '南山区科技园科兴科学园C栋(科苑路西)',
                    // city: '深圳市',
                    // district: '南山区',
                    lat: getUrlParam('lat', sessionStorage.tokenParams), // 纬度
                    lng: getUrlParam('lng', sessionStorage.tokenParams), // 精度
                    // module: 'geolocation',
                    // nation: '中国,
                    // province: '广东省',
                    // type: 'h5_watch',
                },

                swiperImages: [],
                showSwiperImage: false,
                swiperImageIndex: 0,
            },

            mutations: {

                /**
                 * 更新游戏基本信息
                 * @param {Object} state - 状态
                 * @param {String} info - 游戏基本信息
                 */
                updateGameInfo(state, gameInfo) {
                    state.gameInfo = gameInfo
                },

                /**
                 * 更新微社区配置
                 * @param {Object} state - 状态
                 * @param {String} config - 微社区配置
                 */
                updateConfig(state, config) {
                    state.config = config
                },

                /**
                 * 更新访问状态
                 * @param {Object} state - 状态
                 * @param {Boolean} isFirst - 是否首次访问
                 */
                updateIsFirst(state, isFirst) {
                    state.isFirst = isFirst
                },

                /**
                 * 更新微社区配置
                 * @param {Object} state - 状态
                 * @param {Object} userInfo - 用户信息
                 * @param {Object} userInfo.avatar - 用户头像
                 * @param {Object} userInfo.nickname - 用户昵称
                 */
                updateUserInfo(state, userInfo) {
                    state.userInfo = Object.assign({}, state.userInfo, userInfo)
                },

                /**
                 * 更新位置信息
                 * @param {Object} state - 状态
                 * @param {Object} position - 位置信息
                 */
                updatePosition(state, position) {
                    state.position = Object.assign({}, state.position, position)
                },

                /**
                 * 更新标签信息
                 * @param {Object} state - 状态
                 * @param {String} labels - 标签信息
                 */
                updateLabels(state, labels) {
                    state.labels = labels
                },

                /**
                 * 更新微社区知识点
                 * @param {Object} state - 状态
                 * @param {String} knowledge - 微社区知识点
                 */
                updateKnowledge(state, knowledge) {
                    state.knowledge = knowledge
                    // #region 格式化知识点
                    let knowledgeMap = {}
                    let knowledgeSpread = {}
                    Object.entries(knowledge).forEach((item) => {
                        let allKnowledges = []
                        let categories = {}

                        if (item[1].category && Array.isArray(item[1].category)) {

                            // #region 格式化子分类
                            item[1].category.forEach((item => {
                                let knowledges = {}
                                const {kn = []} = item
                                allKnowledges = allKnowledges.concat(kn)
                                kn.forEach((item) => {
                                    knowledges[item.v4_id] = Object.assign({}, item, {
                                        url: JSON.parse(item.url || '[]'),
                                        items: JSON.parse(item.items || '[]'),
                                    })
                                })
                                categories[item.id] = knowledges
                                knowledgeSpread = Object.assign(knowledgeSpread, knowledges)
                            }))
                            // #endregion

                            /* #region 如果子分类为两个及以上，则整合全部子分类 */
                            if (item[1].category.length > 1) {
                                item[1].category.unshift({
                                    id: 0,
                                    name: '全部',
                                    kn: allKnowledges,
                                    game_id: item[1].game_id,
                                    parentid: item[1].id
                                })
                            }
                            /* #endregion */

                        }

                        knowledgeMap[item[0]] = categories
                    })
                    state.knowledgeMap = knowledgeMap
                    state.knowledgeSpread = knowledgeSpread
                    // #endregion

                },

                /**
                 * 更新图片查看器数据
                 * @param {Object} state - 状态
                 * @param {Object} images - 包含图片地址的对象数组
                 */
                updateSwiperImages(state, images) {
                    state.swiperImages = images
                },

                /**
                 * 更新图片查看器状态
                 * @param {Object} state - 状态
                 * @param {Object} show - 是否显示图片查看器
                 */
                updateShowSwiperImage(state, show) {
                    if (show) {
                        history.pushState({}, '', '')
                    }
                    state.showSwiperImage = show
                },

                /**
                 * 更新图片查看器图片默认索引
                 * @param {Object} state - 状态
                 * @param {Object} index - 索引
                 */
                updateSwiperImageIndex(state, index) {
                    state.swiperImageIndex = index
                },
            },

            getters: {
                imagePath(state) {
                    return `//tiem-cdn.qq.com/sy/${state.game}/ingame/images`
                },
                // 群组命名
                groupName(state) {
                    try {
                        return state.config.navigators.moment.groupName ? state.config.navigators.moment.groupName : "群组"
                    } catch (error) {
                        return "群组"
                    }
                },
                // 附近模块是否展示
                locationOpen(state) {
                    try {
                        return state.config.options.locationOpen
                    } catch (error) {
                        return true
                    }
                },
                tglId(state) {
                    try {
                        return state.config.navigators.doujin.tgl_id;
                    } catch (error) {
                        return '';
                    }
                }
            }
        },

        // 我的个人信息
        me: {
            namespaced: true,

            state: {
                areaid: getUrlParam('areaid', sessionStorage.tokenParams), // 账号类型：1（微信），2（QQ）
                platid: getUrlParam('platid', sessionStorage.tokenParams), // 平台类型：0（iOS），1（Android）
                messageNum: 0, // 消息数量
                momentNum: -1,
            },
            mutations: {

                /**
                 * 更新消息数量
                 * @param {Object} state - 状态
                 * @param {Number} number - 微社区配置
                 */
                updateMessageNum(state, number = 0) {
                    state.messageNum = number
                },
                momentNum(state, momentNum) {
                    state.momentNum = momentNum;
                },
                reduceMomentNum(state) {
                    state.momentNum = state.momentNum - 1;
                },
            },
            actions: {
                //我的动态数
                momentNum(context, params) {
                    context.commit('momentNum', params);
                },
                reduceMomentNum(context) {
                    context.commit('reduceMomentNum');
                }
            }
        },

        // 社区模块
        moment: {
            namespaced: true,

            state: {
                list: [],
                scrollTop: 0,
                contentgroup:[],//内容合辑列表
                recommendUser: [] //用户推荐
            },

            mutations: {

                /**
                 * 在头部插入列表项
                 * @param {Object} state - 状态
                 * @param {Object} moment - 动态对象
                 */
                unshiftList(state, moment) {
                    state.list.unshift(moment)
                },
                scrollTop(state, scrollTop) {
                    state.scrollTop = scrollTop;
                },
                updateContentgroup(state, contentgroup) {
                    state.contentgroup = contentgroup
                },
                recommendUserList(state, list) {
                    state.recommendUser = list
                }
            },

            actions: {
                scrollTop(context, params) {
                    context.commit('scrollTop', params);
                },
            }
        },

        //同人模块
        colleagues: {
            namespaced: true,
            state: {
                scrollTop: 0,
                meScrollTop: 0,
                historyScrollTop: 0,
                recommendMix: [],
                isPraise: [],
            },
            mutations: {
                scrollTop(state, scrollTop) {
                    state.scrollTop = scrollTop;
                },
                meScrollTop(state, meScrollTop) {
                    state.meScrollTop = meScrollTop;
                },
                historyScrollTop(state, historyScrollTop) {
                    state.historyScrollTop = historyScrollTop;
                },
                recommendMix(state, recommendMix) {
                    state.recommendMix = recommendMix;
                },
                isPraise(state, isPraise) {
                    state.isPraise = isPraise;
                }
            },
            actions: {
                //同人首页
                scrollTop(context, params) {
                    context.commit('scrollTop', params);
                },
                //我的同人列表页
                meScrollTop(context, params) {
                    context.commit('meScrollTop', params);
                },
                //最近浏览-同人
                historyScrollTop(context, params) {
                    context.commit('historyScrollTop', params);
                },
                //首页-推荐
                recommendMix(context, params) {
                    context.commit('recommendMix', params);
                },
                addIsPraise({commit, state}, params) {
                    let tmp = state.isPraise;
                    if (JSON.stringify(tmp).indexOf(JSON.stringify(params.works_id)) === -1) {
                        tmp.push({...params, is_oper: 1});
                    } else {
                        for (let i = 0; i < tmp.length; i++) {
                            if (tmp[i].works_id === params.works_id) {
                                Object.assign(tmp[i],params);
                                tmp[i].is_oper = 1;
                            }
                        }
                    }
                    commit('isPraise', tmp);
                },
                removeIsPraise({commit, state}, params) {
                    let tmp = state.isPraise;
                    if (JSON.stringify(tmp).indexOf(JSON.stringify(params.works_id)) === -1) {
                        tmp.push({...params, is_oper: 0});
                    } else {
                        for (let i = 0; i < tmp.length; i++) {
                            if (tmp[i].works_id === params.works_id) {
                                Object.assign(tmp[i],params);
                                tmp[i].is_oper = 0;
                            }
                        }
                    }
                    commit('isPraise', tmp);
                },
            }
        }
    }
})